module.exports = __webpack_public_path__ + "static/media/delivered-parcel.9ff3750d.png";